import {AppAction} from "../../../../root/AppAction";
import HeaderEvents from "./HeaderEvents";

export interface HeaderStore {
    from: string;
    to: string;
    direction: string;
}

const initialStore: HeaderStore = {
    from: "/homepage",
    to: "/homepage",
    direction: ""
};

export default function header(state: HeaderStore = initialStore, action: AppAction) {
    if (action.type === HeaderEvents.ChangeMenu) {
        return {
            from: action.from,
            to: action.to,
            direction: action.direction
       };
   } else {
        return state;
   }
}
